export const shouldShowExternalTransferSipServer = (
  sipServer?: string | null,
) => Boolean(sipServer?.trim())
